import React from 'react';

// 122px aus:
// 64px: navBar height +
// 58 px footerbutton (34px dense-button-height + 16px margin-top + 8px margin-bottom)
export const PageContentContainer: React.SFC = props => (
  <div style={{ minHeight: 'calc(100vh - 122px)' }}>{props.children}</div>
);
